import React from 'react';
import { useSpring, animated } from 'react-spring';
import PropTypes from 'prop-types';

const Footer = props => {
  const { show = true, children } = props;
  const style = useSpring({ marginBottom: show ? 0 : -100 });
  return (
    <animated.div className="scan-foot" style={style}>
      {children}
    </animated.div>
  );
};

Footer.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.any,
};

export default Footer;
